/*
 * Desktop-only "dock magnify" hover for the category pill in the header —
 * items scale up smoothly as the cursor gets close, like the macOS Dock.
 * Skipped entirely below 990px (where the hamburger drawer takes over) and
 * for prefers-reduced-motion. Pure transform/opacity, rAF-throttled, no
 * layout thrashing.
 */
(function () {
  var RADIUS = 110;
  var MAX_SCALE = 1.22;
  var LIFT = 6;

  function initDock(list) {
    var items = Array.prototype.slice.call(list.querySelectorAll('.header__menu-item'));
    if (!items.length) return;

    var raf = null;
    var tracking = false;

    function apply(mouseX) {
      items.forEach(function (item) {
        var rect = item.getBoundingClientRect();
        var center = rect.left + rect.width / 2;
        var distance = Math.abs(mouseX - center);
        var influence = Math.max(0, 1 - distance / RADIUS);
        influence = Math.pow(influence, 1.5);
        var scale = 1 + influence * (MAX_SCALE - 1);
        var lift = influence * LIFT;
        item.style.transform = 'translateY(-' + lift.toFixed(2) + 'px) scale(' + scale.toFixed(3) + ')';
      });
    }

    function onMove(e) {
      if (!tracking) {
        tracking = true;
        items.forEach(function (item) {
          item.style.transition = 'none';
        });
      }
      var x = e.clientX;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        apply(x);
      });
    }

    function onLeave() {
      tracking = false;
      if (raf) cancelAnimationFrame(raf);
      items.forEach(function (item) {
        item.style.transition = 'transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)';
        item.style.transform = 'translateY(0) scale(1)';
      });
    }

    list.addEventListener('mousemove', onMove);
    list.addEventListener('mouseleave', onLeave);
  }

  function init() {
    if (window.matchMedia('(max-width: 989px)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var list = document.querySelector('.header--middle-left.header--has-menu .header__inline-menu .list-menu--inline');
    if (list) initDock(list);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
